import ibsTherapy from "../../../assets/IBSTeraphy.png";

export const videos = [
    {
        name: "VIDEO WYKŁAD",
        title: 'Skuteczna terapia IBS',
        subtitle: 'dr n. med. Artur Gradowski',
        image: ibsTherapy,
        description: 'Skuteczne leczenie bólów brzucha stanowi wyzwanie w gabinetach POZ i specjalistów. Jak przekonać pacjenta do stosowania się do zaleceń lekarskich?',
        youtubeLink: 'https://www.youtube.com/watch?v=SV9d-Hfe-vk&t=1s'
    },
    {
        name: "VIDEO WYKŁAD 2",
        title: 'Skuteczna terapia IBS',
        subtitle: 'dr n. med. Artur Gradowski',
        image: ibsTherapy,
        description: 'Skuteczne leczenie bólów brzucha stanowi wyzwanie w gabinetach POZ i specjalistów. Jak przekonać pacjenta do stosowania się do zaleceń lekarskich?',
        youtubeLink: 'https://www.youtube.com/watch?v=SV9d-Hfe-vk&t=1s'
    },
    {
        name: "VIDEO WYKŁAD 3",
        title: 'Skuteczna terapia IBS',
        subtitle: 'dr n. med. Artur Gradowski',
        image: ibsTherapy,
        description: 'Skuteczne leczenie bólów brzucha stanowi wyzwanie w gabinetach POZ i specjalistów. Jak przekonać pacjenta do stosowania się do zaleceń lekarskich?',
        youtubeLink: 'https://www.youtube.com/watch?v=SV9d-Hfe-vk&t=1s'
    },
];